import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const Add = ({ getData, closeAdd, getPesan, setMsg }) => {

  const [loading, setLoading] = useState(false)
  const [fileInput, setFileInput] = useState(null) // Penampung file fisik PDF

  const [formData, setFormData] = useState({
    noPksDpmptsp: '',
    tanggalPksDibuat: '',
    namaVendor: '',
    namaVendorPenanggungJawab: '',
    namaOwner: '',
    namaOwnerPenanggungJawab: '',
    judulPengadaan: '',
    nilaiPenawaran: 0,
    nilaiTransaksi: 0,
    tanggalPengajuan: '',

    tanggalMulai: '',
    tanggalSelesai: '',
    durasiKontrak: '',
    signedFile: ''
  })

  useEffect(() => {
    if (formData.tanggalMulai && formData.tanggalSelesai) {
      const durasi = hitungDurasi(formData.tanggalMulai, formData.tanggalSelesai)
      setFormData(prev => ({ ...prev, durasiKontrak: durasi }))
    }
  }, [formData.tanggalMulai, formData.tanggalSelesai])

  const hitungDurasi = (start, end) => {
    if (!start || !end) return ''

    const startDate = new Date(start)
    const endDate = new Date(end)

    let years = endDate.getFullYear() - startDate.getFullYear()
    let months = endDate.getMonth() - startDate.getMonth()
    let days = endDate.getDate() - startDate.getDate()

    if (days < 0) {
      months--
      const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
      days += prevMonth.getDate()
    }
    if (months < 0) {
      years--
      months += 12
    }

    let result = []
    if (years > 0) result.push(`${years} Tahun`)
    if (months > 0) result.push(`${months} Bulan`)
    if (days > 0) result.push(`${days} Hari`)

    return result.join(' ')
  }

  const proses = async (e) => {
    e.preventDefault()
    setLoading(true)

    const dataToSend = new FormData()

    // Masukin semua field text/number
    Object.keys(formData).forEach(key => {
      if (key !== 'signedFile') {
        dataToSend.append(key, formData[key])
      }
    })

    // Tembak file PDF fisiknya ke FormData
    if (fileInput) {
      dataToSend.append('signedFile', fileInput)
    } else {
      getPesan()
      setMsg('Wajib mengunggah file scan PKS fisik!')
      setLoading(false)
      return
    }

    try {
      const response = await axiosJWT.post(`/api/pks-mandiri/create`, dataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      getPesan()
      setMsg(response.data.msg)
      setTimeout(() => {
        getPesan()
        setMsg('')
        getData('')
        closeAdd()
      }, 2000)
    } catch (err) {
      getPesan()
      const errorMsg = (err.response && err.response.data && err.response.data.msg)
        ? err.response.data.msg
        : 'Maaf, proses pengiriman data gagal!'
      setMsg(errorMsg)
      setTimeout(() => {
        getPesan()
        setMsg('')
      }, 4000)
    } finally {
      setLoading(false)
    }
  }

  return (<>
    <form onSubmit={proses} className="form-horizontal" encType="multipart/form-data">
      <div className="row">

        {/* Row 1: Nomor PKS Utama */}
        <div className="form-group col-md-12">
          <label className="control-label">Nomor PKS</label>
          <input type="text" className="form-control" value={formData.noPksDpmptsp} onChange={(e) => setFormData({ ...formData, noPksDpmptsp: e.target.value })} placeholder="Masukkan nomor PKS resmi..." required />
        </div>

        {/* Row 2: Kronologi Tanggal (Dibuat & Diajukan) */}
        <div className="form-group col-md-6">
          <label className="control-label">Tanggal Dokumen PKS Dibuat</label>
          <input type="date" className="form-control" value={formData.tanggalPksDibuat} onChange={(e) => setFormData({ ...formData, tanggalPksDibuat: e.target.value })} required />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Tanggal Pengajuan Kontrak</label>
          <input type="date" className="form-control" value={formData.tanggalPengajuan} onChange={(e) => setFormData({ ...formData, tanggalPengajuan: e.target.value })} />
        </div>

        {/* Row 3: Judul Kegiatan */}
        <div className="form-group col-md-12">
          <label className="control-label">Judul Pengadaan / Nama Kegiatan</label>
          <input type="text" className="form-control" value={formData.judulPengadaan} onChange={(e) => setFormData({ ...formData, judulPengadaan: e.target.value })} placeholder="Contoh: Pengadaan Alat Tulis Kantor..." required />
        </div>

        {/* Row 4: Identitas Pihak */}
        <div className="form-group col-md-6">
          <label className="control-label">Pihak Kesatu (Nama Badan)</label>
          <input type="text" className="form-control" value={formData.namaOwner} onChange={(e) => setFormData({ ...formData, namaOwner: e.target.value })} placeholder="Masukkan nama pelaku usaha" required />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Pihak Kesatu (Penanggung Jawab)</label>
          <input type="text" className="form-control" value={formData.namaOwnerPenanggungJawab} onChange={(e) => setFormData({ ...formData, namaOwnerPenanggungJawab: e.target.value })} required />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Pihak Kedua (Nama Badan/Usaha)</label>
          <input type="text" className="form-control" value={formData.namaVendor} onChange={(e) => setFormData({ ...formData, namaVendor: e.target.value })} placeholder="Masukkan nama vendor" required />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Pihak Kedua (Penanggung Jawab)</label>
          <input type="text" className="form-control" value={formData.namaVendorPenanggungJawab} onChange={(e) => setFormData({ ...formData, namaVendorPenanggungJawab: e.target.value })} required />
        </div>

        {/* Row 5: Nilai Anggaran */}
        <div className="form-group col-md-6">
          <label className="control-label">Nilai Penawaran (Rp)</label>
          <input type="number" className="form-control" value={formData.nilaiPenawaran} onChange={(e) => setFormData({ ...formData, nilaiPenawaran: e.target.value })} />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Nilai Transaksi Kontrak / PKS (Rp)</label>
          <input type="number" className="form-control" value={formData.nilaiTransaksi} onChange={(e) => setFormData({ ...formData, nilaiTransaksi: e.target.value })} required />
        </div>

        {/* Row 6: Durasi Kontrak */}
        <div className="form-group col-md-4">
          <label className="control-label">Tanggal Kontrak Mulai</label>
          <input type="date" className="form-control" value={formData.tanggalMulai} onChange={(e) => setFormData({ ...formData, tanggalMulai: e.target.value })} required />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Tanggal Kontrak Selesai</label>
          <input type="date" className="form-control" value={formData.tanggalSelesai} onChange={(e) => setFormData({ ...formData, tanggalSelesai: e.target.value })} required />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Durasi Kontrak (Otomatis)</label>
          <input type="text" className="form-control" value={formData.durasiKontrak} readOnly style={{ backgroundColor: '#eee', fontWeight: 'bold' }} />
        </div>

        {/* Row 7: File Attachment */}
        {/* Row 7: File Attachment - Mengikuti Struktur Murni Template Material Design (Mode: Tambah Data) */}
        <div className="form-group col-md-12">
          <label className="control-label">Upload Berkas Fisik PKS (Format: PDF)</label>
          <div className="form-group is-empty is-fileinput" style={{ margin: 0, paddingBottom: 0 }}>
            {/* Input file asli yang menangani event onChange + required */}
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => setFileInput(e.target.files[0])}
              required
            />
            {/* Layer visual palsu bawaan template MD biar sinkron bray */}
            <div className="input-group">
              <input
                type="text"
                readOnly
                className="form-control"
                placeholder={fileInput ? fileInput.name : "Klik ikon klip di kanan untuk upload file PDF (Wajib)..."}
              />
              <span className="input-group-btn input-group-sm">
                <button type="button" className="btn btn-fab btn-fab-mini">
                  <i className="fa fa-file-archive-o"></i>
                </button>
              </span>
            </div>
          </div>
          <small className="text-muted" style={{ display: 'block', marginTop: '5px', fontStyle: 'italic', fontSize: '11px' }}>
            *Wajib melampirkan berkas hasil scan PKS asli format PDF.
          </small>
        </div>

      </div>

      <div className="modal-footer" style={{ marginTop: '20px' }}>
        <button disabled={loading} className="btn btn-raised btn-success br-2" type="submit">
          <i className="fa fa-save"></i> {loading ? 'Menyimpan...' : 'Simpan Pencatatan'}
        </button>
        <button className="btn btn-raised btn-danger br-2" type="button" onClick={closeAdd}><i className="fa fa-sign-out"></i> Tutup</button>
      </div>
    </form>
  </>)
}